import { render, staticRenderFns } from "./SeriesClassOption.vue?vue&type=template&id=53b674c2&scoped=true&"
import script from "./SeriesClassOption.vue?vue&type=script&lang=js&"
export * from "./SeriesClassOption.vue?vue&type=script&lang=js&"
import style0 from "./SeriesClassOption.vue?vue&type=style&index=0&id=53b674c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b674c2",
  null
  
)

export default component.exports